module.exports = __webpack_public_path__ + "static/aha-b42ad6846e356bc9fa224ac1dd03dd97.jpg";